export const addIndefiniteArticle = (word) => {
  if (!word || word.length < 1) {
    return '';
  }
  const vowels = ['a', 'e', 'i', 'o', 'u'];
  return vowels.includes(word[0].toLowerCase()) ? 'an' : 'a';
};
